import { canShareCustomerBooking } from "../../components/Node/customerBookingQr";
import { DOCTOR_SCHEDULE_ROLES } from "../../components/Booking/doctorScheduleAccess";
import React, { Component } from "react";

/// Link
import { Link } from "react-router-dom";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Menu
import MetisMenu from "metismenujs";
import { AuthContext } from "../../../context/AuthContext";
import { useAdminCustomerMenuRestriction } from "../../../hook/useAdminCustomerMenuRestriction";
import { usePaymentAccessScope } from "../../../hook/usePaymentAccessScope";
import { canManageComplaints } from "../../components/PatientPortal/patientPortalComplaintUtils";
import PatientPortalShareModal from "../../components/PatientPortal/PatientPortalShareModal";
import { isStaffCpapFollowupViewer } from "../../components/Followup/cpapFollowupAccess";
import { canViewRoleSummary } from "../../components/Admin/RoleSummaryData";
import {
  hasPaymentDashboardViewRole,
  TECH_DASHBOARD_VIEW_ROLES,
} from "../../paymentDashboardAccess";

///
// import icon1 from "../../../images/icon1.png";

class MM extends Component {
  // static contextType = AuthContext;
  componentDidMount() {
    // console.log(this.context.currentUser);
    // if (this.context.currentUser == null) {
    //   window.location.pathname = "/page-login";
    // }
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.hideCustomerRestrictedMenus !== this.props.hideCustomerRestrictedMenus
    ) {
      this.mm.dispose();
      this.mm.update();
    }
  }
  componentWillUnmount() {
    this.mm.dispose();
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const PaymentAccessNavLink = ({ path, canOpen }) => {
  const { loading, paymentAccess } = usePaymentAccessScope();

  if (!canOpen || loading || !paymentAccess) return null;

  return (
    <li>
      <Link
        className={`${path === "payment-access-config" ? "mm-active" : ""}`}
        to="/payment-access-config"
      >
        Payment Access
      </Link>
    </li>
  );
};

const PatientPortalTicketNavLink = ({ path, currentRoles }) => {
  if (!currentRoles.includes("super_admin")) return null;
  return <li className={["patient-portal-tickets", "patient-portal-complaints"].includes(path) ? "mm-active" : ""}>
    <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
      <i className="fa fa-ticket" /><span className="nav-text">Patient Tickets</span>
    </Link>
    <ul aria-expanded="false">
      <li><Link className={path === "patient-portal-tickets" ? "mm-active" : ""} to="/patient-portal-tickets">Patient Tickets</Link></li>
      {canManageComplaints(currentRoles) && <li><Link className={path === "patient-portal-complaints" ? "mm-active" : ""} to="/patient-portal-complaints">Complaints</Link></li>}
    </ul>
  </li>;
};

const PaymentDashboardNav = ({
  currentUser,
  currentRoles,
  path,
  hideCustomerRestrictedMenus,
}) => {
  const {
    loading: techScopeLoading,
    canManagePayments: canManageTechPayments,
  } = usePaymentAccessScope("sleep_technician");
  const {
    loading: doctorScopeLoading,
    canManagePayments: canManageDoctorPayments,
  } = usePaymentAccessScope("sleep_physician");

  const isSuperAdmin = currentRoles.includes("super_admin");
  const canShowDashboardHome = [
    "super_admin",
    "sale",
    "accountant",
    "sleep_technician",
    "sleep_physician",
    "staff",
    "admin",
  ].some((role) => currentRoles.includes(role));
  const canOpenTechDashboard =
    !hideCustomerRestrictedMenus &&
    (hasPaymentDashboardViewRole(currentRoles, TECH_DASHBOARD_VIEW_ROLES) ||
      (!techScopeLoading && canManageTechPayments));
  const canOpenDoctorDashboard =
    isSuperAdmin ||
    currentRoles.includes("sleep_physician") ||
    (!doctorScopeLoading && canManageDoctorPayments);

  if (
    !currentUser ||
    (!canShowDashboardHome &&
      !canOpenTechDashboard &&
      !canOpenDoctorDashboard)
  ) {
    return null;
  }

  return (
    <li
      className={`${
        ["dashboard", "tech-dashboard", "doctor-dashboard"].includes(path)
          ? "mm-active"
          : ""
      }`}
    >
      <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
        <i className="flaticon-381-background"></i>
        <span className="nav-text">Dashboard</span>
      </Link>
      <ul aria-expanded="false">
        {canShowDashboardHome && (
          <li>
            <Link
              className={`${path === "dashboard" ? "mm-active" : ""}`}
              to="/dashboard"
            >
              Dashboard
            </Link>
          </li>
        )}
        {canOpenTechDashboard && (
          <li>
            <Link
              className={`${path === "tech-dashboard" ? "mm-active" : ""}`}
              to="/tech-dashboard"
            >
              Technician Dashboard
            </Link>
          </li>
        )}
        {canOpenDoctorDashboard && (
          <li>
            <Link
              className={`${path === "doctor-dashboard" ? "mm-active" : ""}`}
              to="/doctor-dashboard"
            >
              Doctor Dashboard
            </Link>
          </li>
        )}
      </ul>
    </li>
  );
};

class SideBar extends Component {
  /// Open menu
  static contextType = AuthContext;
  state = { showPatientPortalShare: false };
  componentDidMount() {
    // sidebar open/close
    // console.log(this.context.currentUser);
    if (this.context.currentUser == null) {
      window.location.pathname = "/page-login";
    }
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }

    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector(".heart");

    function heartBlast() {
      return handleheartBlast.classList.toggle("heart-blast");
    }

    handleheartBlast.addEventListener("click", heartBlast);
  }
  render() {
    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];
    const currentRoles =
      this.context.currentUser && Array.isArray(this.context.currentUser.roles)
        ? this.context.currentUser.roles
        : [];
    const currentRole =
      currentRoles.length > 0 ? currentRoles[0] : "";
    const { hideCustomerRestrictedMenus } = this.props;
    const isSuperAdmin = currentRoles.includes("super_admin");
    const canSharePatientPortal = currentRoles.some((role) =>
      ["super_admin", "admin", "staff", "sale"].includes(role),
    );
    const isStaffFollowupViewer = isStaffCpapFollowupViewer(
      this.context.currentUser,
    );
    const canShowRoleSummary = canViewRoleSummary(
      this.context.currentUser,
    );
    const canShowFollowup =
      !currentRoles.includes("sleep_technician") &&
      currentRoles.some((role) =>
        [
          "super_admin",
          "sale",
          "accountant",
          "admin",
          "staff",
          "sleep_physician",
        ].includes(role),
      );
    const canShowFeatureRequests =
      !hideCustomerRestrictedMenus && currentRoles.some((role) =>
        [
          "super_admin",
          "admin",
          "sleep_technician",
          "sale",
          "accountant",
        ].includes(role),
      );
    const canManageCpapTrialRecovery =
      !hideCustomerRestrictedMenus && currentRoles.some((role) =>
        ["super_admin", "admin"].includes(role),
      );

    /// Active menu
    let admin = [
        "",
        "admin-list",
        "admin-node",
        "admin-form",
        "patient-portal-ticket-access",
        "summarize-role",
        "create-account-guide",
      ],
      booking = [
        "booking-calendar",
        "booking-table",
        "booking-recovery",
        "booking-urgent",
        "sleep-study-monitor",
        "sleep-study-monitor-flow",
        "technician-schedule",
        "doctor-schedule",
      ],
      followup = [
        "cpap-followup-dashboard",
        "cpap-followup-calendar",
        "cpap-followup-table",
        "annual-mask-purchase",
        "followup-record-history",
        "annual-mask-purchase-guide",
        "cpap-followup-guide",
        "followup-calendar",
        "followup-table",
      ],
      patient = [
        "patient-list",
        "patient-page",
        "patient-register",
        "patient-incoming",
      ],
      node = ["node-list"],
      cpap = [
        "cpap-list",
        "cpap-register",
        "cpap-page",
        "trial-inventory",
        "mask-inventory",
        "mask-transaction",
        "cpap-trial-recovery",
        "cpap-trial-service-list",
        "cpap-trial-service-create",
        "cpap-trial-external-repair-list",
      ],
      product = [
        "product-list",
        "product-register",
        // "order-list", // ไม่ใช้แล้ว — ใช้ new-order-list แทน
        // "inventory",
        "accessories-list",
        "new-order",
        "new-order-list",
        "material-issue-list",
        "stock-logs-list",
      ],
      featureRequest = ["feature-request-list"],
      items = [
        "sale-package-list",
        "item-list",
        "mask-list",
        "cpap-service",
        "tech-list",
        "sale-list",
        "doctor-list",
        "accountant-list",
        "approver-list",
      ],
      Export = ["export"],
      Service = ["service-ticket-list", "external-repair-list"],
      Equipment = [
        "equipment-list",
        "sensor-stock",
        "sleep-study-equipment",
        "ticket-list",
      ],
      Backup = ["backup"],
      Settings = ["settings"];

    admin.push(
      "payment-access-config",
      "recovery-delete-access",
      "annual-mask-access",
      "email-sender-settings",
    );

    return (
      <div className="deznav border-right">
        <PerfectScrollbar className="deznav-scroll">
          <MM
            className="metismenu"
            id="menu"
            hideCustomerRestrictedMenus={hideCustomerRestrictedMenus}
          >
            <PaymentDashboardNav
              currentUser={this.context.currentUser}
              currentRoles={currentRoles}
              hideCustomerRestrictedMenus={hideCustomerRestrictedMenus}
              path={path}
            />
            {this.context.currentUser && <PatientPortalTicketNavLink path={path} currentRoles={currentRoles} />}
            <li className={`${admin.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
                <i className="flaticon-381-infinity"></i>
                <span className="nav-text">Admin</span>
              </Link>
              <ul aria-expanded="false">
                <li>
                  <Link
                    className={`${path === "" ? "mm-active" : ""}`}
                    to="/"
                    // onClick={() => (window.location.pathname = "/")}
                  >
                    Your Account
                  </Link>
                </li>
                {this.context.currentUser &&
                  currentRoles.includes("super_admin") && (
                    <li>
                      <Link
                        className={`${
                          path === "admin-list" ? "mm-active" : ""
                        }`}
                        to="/admin-list"
                        // onClick={() => (window.location.pathname = "/admin-list")}
                      >
                        Accounts
                      </Link>
                    </li>
                  )}
                {this.context.currentUser && (
                  <PaymentAccessNavLink
                    path={path}
                    canOpen={
                      isSuperAdmin ||
                      currentRoles.includes("sleep_technician") ||
                      currentRoles.includes("sleep_physician")
                    }
                  />
                )}
                {this.context.currentUser && isSuperAdmin && (
                  <li>
                    <Link
                      className={`${
                        path === "recovery-delete-access" ? "mm-active" : ""
                      }`}
                      to="/recovery-delete-access"
                    >
                      Recovery Delete Access
                    </Link>
                  </li>
                )}
                {this.context.currentUser && isSuperAdmin && (
                  <li>
                    <Link
                      className={`${
                        path === "annual-mask-access" ? "mm-active" : ""
                      }`}
                      to="/annual-mask-access"
                    >
                      Annual Mask Access
                    </Link>
                  </li>
                )}
                {this.context.currentUser && isSuperAdmin && (
                  <li>
                    <Link
                      className={path === "email-sender-settings" ? "mm-active" : ""}
                      to="/email-sender-settings"
                    >
                      Email Sender Settings
                    </Link>
                  </li>
                )}
                {this.context.currentUser && isSuperAdmin && (
                  <li><Link className={path === "patient-portal-ticket-access" ? "mm-active" : ""} to="/patient-portal-ticket-access">Patient Portal Ticket Access</Link></li>
                )}
                {this.context.currentUser && canShowRoleSummary && (
                  <li>
                    <Link
                      className={
                        path === "summarize-role" ? "mm-active" : ""
                      }
                      to="/summarize-role"
                    >
                      Summarize Role
                    </Link>
                  </li>
                )}
                {this.context.currentUser && isSuperAdmin && (
                  <li>
                    <Link
                      className={path === "create-account-guide" ? "mm-active" : ""}
                      to="/create-account-guide"
                    >
                      Create Account Guide
                    </Link>
                  </li>
                )}
              </ul>
            </li>
            {canShareCustomerBooking(this.context.currentUser) && (
                <li className={`${node.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i className="flaticon-381-location"></i>
                    <span className="nav-text">Node</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${path === "node-list" ? "mm-active" : ""}`}
                        to="/node-list"
                        // onClick={() => (window.location.pathname = "/node-list")}
                      >
                        Our Nodes
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            {this.context.currentUser &&
              (canSharePatientPortal || currentRole === "accountant") && (
                <li className={`${patient.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i className="flaticon-381-user-9"></i>
                    <span className="nav-text">Patient</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${
                          path === "patient-list" ? "mm-active" : ""
                        }`}
                        to="/patient-list"
                      >
                        Search Patient
                      </Link>
                    </li>
                    {this.context.currentUser &&
                      ["super_admin", "admin", "staff"].includes(
                        this.context.currentUser.roles[0],
                      ) && (
                        <li>
                          <Link
                            className={`${
                              path === "patient-incoming" ? "mm-active" : ""
                            }`}
                            to="/patient-incoming"
                          >
                            Incoming Patients
                          </Link>
                        </li>
                      )}
                    {this.context.currentUser &&
                      ["super_admin", "admin"].includes(
                        this.context.currentUser.roles[0],
                      ) && (
                        <li>
                          <Link
                            className={`${
                              path === "patient-register" ? "mm-active" : ""
                            }`}
                            to="/patient-register"
                          >
                            New Patient
                          </Link>
                        </li>
                      )}
                    {canSharePatientPortal && (
                      <li>
                        <button
                          type="button"
                          className="patient-portal-share-shortcut"
                          aria-haspopup="dialog"
                          aria-controls="patient-portal-share-dialog"
                          aria-expanded={this.state.showPatientPortalShare}
                          onClick={() => {
                            this.setState({ showPatientPortalShare: true });
                          }}
                        >
                          <i className="fa fa-share-alt" aria-hidden="true" />
                          <span>Share Patient Portal</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            <li className={`${booking.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
                <i class="flaticon-381-calendar-2"></i>{" "}
                <span className="nav-text">Booking</span>
              </Link>
              <ul aria-expanded="false">
                <li>
                  <Link
                    className={`${
                      path === "booking-calendar" ? "mm-active" : ""
                    }`}
                    to="/booking-calendar"
                  >
                    Calendar
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${path === "booking-table" ? "mm-active" : ""}`}
                    to="/booking-table"
                  >
                    Table
                  </Link>
                </li>
                {!hideCustomerRestrictedMenus && this.context.currentUser &&
                  ["super_admin", "admin"].includes(
                    this.context.currentUser.roles[0],
                  ) && (
                    <>
                      <li>
                        <Link
                          className={
                            path === "sleep-study-monitor"
                              ? "mm-active"
                              : ""
                          }
                          to="/sleep-study-monitor"
                        >
                          Sleep Study Monitor
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            path === "sleep-study-monitor-flow"
                              ? "mm-active"
                              : ""
                          }
                          to="/sleep-study-monitor-flow"
                        >
                          Sleep Study Guide
                        </Link>
                      </li>
                    </>
                  )}
                {!hideCustomerRestrictedMenus && this.context.currentUser &&
                  [
                    "super_admin",
                    "sale",
                    "accountant",
                    "sleep_technician",
                    "admin",
                  ].includes(this.context.currentUser.roles[0]) && (
                    <>
                      <li>
                        <Link
                          className={
                            path === "booking-urgent" ? "mm-active" : ""
                          }
                          to="/booking-urgent"
                        >
                          Urgent Cases
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            path === "technician-schedule" ? "mm-active" : ""
                          }
                          to="/technician-schedule"
                        >
                          Technician Schedule
                        </Link>
                      </li>
                    </>
                  )}
                {!hideCustomerRestrictedMenus && currentRoles.some((role) =>
                  DOCTOR_SCHEDULE_ROLES.includes(role),
                ) && (
                  <li>
                    <Link
                      className={path === "doctor-schedule" ? "mm-active" : ""}
                      to="/doctor-schedule"
                    >
                      Doctor Schedule
                    </Link>
                  </li>
                )}
                {!hideCustomerRestrictedMenus && currentRoles.some((role) =>
                  ["super_admin", "admin"].includes(role),
                ) && (
                  <li>
                    <Link
                      className={`${
                        path === "booking-recovery" ? "mm-active" : ""
                      }`}
                      to="/booking-recovery"
                    >
                      Recovery & Delete Log
                    </Link>
                  </li>
                )}
              </ul>
            </li>
            {this.context.currentUser &&
              (["super_admin", "sale", "accountant"].includes(
                this.context.currentUser.roles[0],
              ) ? (
                <li className={`${cpap.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i class="flaticon-381-briefcase"></i>{" "}
                    <span className="nav-text">CPAP Trial</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${
                          path === "trial-calendar" ? "mm-active" : ""
                        }`}
                        to="/trial-calendar"
                      >
                        Trial Calendar
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${path === "cpap-list" ? "mm-active" : ""}`}
                        to="/cpap-list"
                      >
                        Search CPAP Trial
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "cpap-register" ? "mm-active" : ""
                        }`}
                        to="/cpap-register"
                      >
                        Register CPAP Trial
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        className={`${
                          path === "trial-inventory" ? "mm-active" : ""
                        }`}
                        to="/trial-inventory"
                      >
                        Trial Inventory
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        className={`${
                          path === "mask-inventory" ? "mm-active" : ""
                        }`}
                        to="/mask-inventory"
                      >
                        Mask Inventory
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "mask-transaction" ? "mm-active" : ""
                        }`}
                        to="/mask-transaction"
                      >
                        Mask Transaction
                      </Link>
                    </li>
                    {!hideCustomerRestrictedMenus && currentRole !== "staff" && (
                      <li>
                        <Link
                          className={`${
                            path === "cpap-trial-service-list"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/cpap-trial-service-list"
                        >
                          Service
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        className={`${
                          path === "cpap-trial-external-repair-list"
                            ? "mm-active"
                            : ""
                        }`}
                        to="/cpap-trial-external-repair-list"
                      >
                        External Repair
                      </Link>
                    </li>
                    {canManageCpapTrialRecovery && (
                      <li>
                        <Link
                          className={`${
                            path === "cpap-trial-recovery" ? "mm-active" : ""
                          }`}
                          to="/cpap-trial-recovery"
                        >
                          Recovery & Delete Log
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              ) : ["staff", "admin"].includes(
                  this.context.currentUser.roles[0],
                ) ? (
                <li className={`${cpap.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i class="flaticon-381-briefcase"></i>{" "}
                    <span className="nav-text">CPAP Trial</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${
                          path === "trial-calendar" ? "mm-active" : ""
                        }`}
                        to="/trial-calendar"
                      >
                        Trial Calendar
                      </Link>
                    </li>
                    {!hideCustomerRestrictedMenus && currentRole !== "staff" && (
                      <li>
                        <Link
                          className={`${
                            path === "cpap-trial-service-list"
                              ? "mm-active"
                              : ""
                          }`}
                          to="/cpap-trial-service-list"
                        >
                          Service
                        </Link>
                      </li>
                    )}
                    {/* <li>
                      <Link
                        className={`${
                          path === "cpap-trial-external-repair-list"
                            ? "mm-active"
                            : ""
                        }`}
                        to="/cpap-trial-external-repair-list"
                      >
                        External Repair
                      </Link>
                    </li> */}
                    {canManageCpapTrialRecovery && (
                      <li>
                        <Link
                          className={`${
                            path === "cpap-trial-recovery" ? "mm-active" : ""
                          }`}
                          to="/cpap-trial-recovery"
                        >
                          Recovery & Delete Log
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              ) : null)}
            {this.context.currentUser ? (
              canShowFollowup && (
                <>
                  {" "}
                  {this.context.currentUser ? (
                    canShowFollowup && (
                      <>
                        <li
                          className={`${
                            followup.includes(path) ? "mm-active" : ""
                          }`}
                        >
                          <Link
                            className="has-arrow ai-icon"
                            to="#"
                            aria-expanded="false"
                          >
                            <i class="flaticon-381-clock-2"></i>{" "}
                            <span className="nav-text">CPAP Follow-Up</span>
                          </Link>
                          <ul aria-expanded="false">
                            {!isStaffFollowupViewer && (
                              <li>
                                <Link
                                  className={`${
                                    path === "cpap-followup-dashboard"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="/cpap-followup-dashboard"
                                >
                                  Follow-Up Dashboard
                                </Link>
                              </li>
                            )}
                            <li>
                              <Link
                                className={`${
                                  path === "cpap-followup-calendar"
                                    ? "mm-active"
                                    : ""
                                }`}
                                to="/cpap-followup-calendar"
                              >
                                Follow-Up Calendar
                              </Link>
                            </li>
                            {!isStaffFollowupViewer && (
                              <>
                                <li>
                                  <Link
                                    className={`${
                                      path === "cpap-followup-table"
                                        ? "mm-active"
                                        : ""
                                    }`}
                                    to="/cpap-followup-table"
                                  >
                                    Follow-Up Table
                                  </Link>
                                </li>
                                {currentRoles.some((role) =>
                                  [
                                    "super_admin",
                                    "admin",
                                    "sale",
                                    "accountant",
                                    "sleep_physician",
                                  ].includes(role),
                                ) && (
                                  <li>
                                    <Link
                                      className={`${
                                        path === "annual-mask-purchase"
                                          ? "mm-active"
                                          : ""
                                      }`}
                                      to="/annual-mask-purchase"
                                    >
                                      Annual Mask Batch Review
                                    </Link>
                                  </li>
                                )}
                                <li>
                                  <Link
                                    className={`${
                                      path === "followup-record-history"
                                        ? "mm-active"
                                        : ""
                                    }`}
                                    to="/followup-record-history"
                                  >
                                    Follow-Up History
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={path === "annual-mask-purchase-guide" ? "mm-active" : ""}
                                    to="/annual-mask-purchase-guide"
                                  >
                                    Annual Mask Purchase Guide
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={path === "cpap-followup-guide" ? "mm-active" : ""}
                                    to="/cpap-followup-guide"
                                  >
                                    Follow-Up Guide
                                  </Link>
                                </li>
                              </>
                            )}
                            {isSuperAdmin && (
                              <li>
                                <Link
                                  className={`${
                                    path === "followup-calendar"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="/followup-calendar"
                                >
                                  Calendar
                                </Link>
                              </li>
                            )}
                            {isSuperAdmin && (
                              <li>
                                <Link
                                  className={`${
                                    path === "followup-table"
                                      ? "mm-active"
                                      : ""
                                  }`}
                                  to="/followup-table"
                                >
                                  Table
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      </>
              )
            ) : (
              <></>
            )}
                  {!hideCustomerRestrictedMenus && this.context.currentUser &&
                    ["super_admin", "sale", "accountant", "admin"].includes(
                      this.context.currentUser.roles[0],
                    ) && (
                      <li
                        className={`${
                          product.includes(path) ? "mm-active" : ""
                        }`}
                      >
                        <Link
                          className="has-arrow ai-icon"
                          to="#"
                          aria-expanded="false"
                        >
                          <i className="flaticon-381-box-1"></i>
                          <span className="nav-text">Sales</span>
                        </Link>
                        <ul aria-expanded="false">
                          <li>
                            <Link
                              className={`${
                                path === "product-list" ? "mm-active" : ""
                              }`}
                              to="/product-list"
                            >
                              Product List
                            </Link>
                          </li>
                          {/* ไม่ใช้แล้ว — ใช้ New Order List (/sale-order-list) แทน
                          <li>
                            <Link
                              className={`${
                                path === "order-list" ? "mm-active" : ""
                              }`}
                              to="/order-list"
                            >
                              Order List
                            </Link>
                          </li>
                          */}
                          <li>
                            <Link
                              className={`${
                                path === "new-order-list" ? "mm-active" : ""
                              }`}
                              to="/sale-order-list"
                            >
                              New Order List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "new-order" ? "mm-active" : ""
                              }`}
                              to="/new-order"
                            >
                              Create Order
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "product-register" ? "mm-active" : ""
                              }`}
                              to="/product-register"
                            >
                              Product Register
                            </Link>
                          </li>
                          {/* <li>
                            <Link
                              className={`${
                                path === "inventory" ? "mm-active" : ""
                              }`}
                              to="/inventory"
                            >
                              Inventory
                            </Link>
                          </li> */}
                          <li>
                            <Link
                              className={`${
                                path === "accessories-list" ? "mm-active" : ""
                              }`}
                              to="/accessories-list"
                            >
                              Accessories
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "material-issue-list"
                                  ? "mm-active"
                                  : ""
                              }`}
                              to="/material-issue-list"
                            >
                              Material Issue
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "stock-logs-list" ? "mm-active" : ""
                              }`}
                              to="/stock-logs-list"
                            >
                              Stock Logs
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}

                </>
              )
            ) : (
              <> </>
            )}
                  {!hideCustomerRestrictedMenus && currentRoles.some((role) => ["super_admin", "admin"].includes(role)) && (
                      <li
                        className={`${items.includes(path) ? "mm-active" : ""}`}
                      >
                        <Link
                          className="has-arrow ai-icon"
                          to="#"
                          aria-expanded="false"
                        >
                          <i class="flaticon-381-album-2"></i>{" "}
                          <span className="nav-text">Items</span>
                        </Link>
                        <ul aria-expanded="false">
                          <li>
                            <Link
                              className={path === "sale-package-list" ? "mm-active" : ""}
                              to="/sale-package-list"
                            >
                              Sale Package List
                            </Link>
                          </li>

                          <li>
                            <Link
                              className={`${
                                path === "item-list" ? "mm-active" : ""
                              }`}
                              to="/item-list"
                              // onClick={() => (window.location.pathname = "/node-list")}
                            >
                              Item List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "mask-list" ? "mm-active" : ""
                              }`}
                              to="/mask-list"
                            >
                              Mask List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "cpap-service" ? "mm-active" : ""
                              }`}
                              to="/cpap-service"
                            >
                              CPAP Service
                            </Link>
                          </li>

                          <li>
                            <Link
                              className={`${
                                path === "tech-list" ? "mm-active" : ""
                              }`}
                              to="/tech-list"
                              // onClick={() => (window.location.pathname = "/node-list")}
                            >
                              Technician List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "sale-list" ? "mm-active" : ""
                              }`}
                              to="/sale-list"
                              // onClick={() => (window.location.pathname = "/node-list")}
                            >
                              Sale List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "doctor-list" ? "mm-active" : ""
                              }`}
                              to="/doctor-list"
                              // onClick={() => (window.location.pathname = "/node-list")}
                            >
                              Doctor List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "accountant-list" ? "mm-active" : ""
                              }`}
                              to="/accountant-list"
                              // onClick={() => (window.location.pathname = "/node-list")}
                            >
                              Accountant List
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`${
                                path === "approver-list" ? "mm-active" : ""
                              }`}
                              to="/approver-list"
                            >
                              Approver List
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}
            {this.context.currentUser && canShowFeatureRequests && (
              <li
                className={`${
                  featureRequest.includes(path) ? "mm-active" : ""
                }`}
              >
                <Link
                  className="has-arrow ai-icon"
                  to="#"
                  aria-expanded="false"
                >
                  <i className="flaticon-381-notepad"></i>
                  <span className="nav-text">Product Requests</span>
                </Link>
                <ul aria-expanded="false">
                  <li>
                    <Link
                      className={`${
                        path === "feature-request-list" ? "mm-active" : ""
                      }`}
                      to="/feature-request-list"
                    >
                      Request List
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            <li className={`${Export.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
                <i class="flaticon-381-download"></i>{" "}
                <span className="nav-text">Export</span>
              </Link>
              <ul aria-expanded="false">
                <li>
                  <Link
                    className={`${path === "export" ? "mm-active" : ""}`}
                    to="/export"
                    // onClick={() => (window.location.pathname = "/node-list")}
                  >
                    Export
                  </Link>
                </li>
              </ul>
            </li>
            {this.context.currentUser &&
              ["super_admin", "sale", "accountant"].includes(
                this.context.currentUser.roles[0],
              ) && (
                <li className={`${Service.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i class="flaticon-381-file-1"></i>{" "}
                    <span className="nav-text">Service</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${
                          path === "service-ticket-list" ? "mm-active" : ""
                        }`}
                        to="/service-ticket-list"
                      >
                        Customer Service
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "external-repair-list" ? "mm-active" : ""
                        }`}
                        to="/external-repair-list"
                      >
                        External Repair
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        className={`${
                          path === "equipment-list" ? "mm-active" : ""
                        }`}
                        to="/equipment-list"
                      >
                        Equipments
                      </Link>
                    </li> */}
                  </ul>
                </li>
              )}
            {this.context.currentUser &&
              ["super_admin"].includes(
                this.context.currentUser.roles[0],
              ) && (
                <li
                  className={`${Equipment.includes(path) ? "mm-active" : ""}`}
                >
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i className="flaticon-381-file-1"></i>{" "}
                    <span className="nav-text">Equipments</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${
                          path === "equipment-list" ? "mm-active" : ""
                        }`}
                        to="/equipment-list"
                      >
                        Equipments
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "ticket-list" ? "mm-active" : ""
                        }`}
                        to="/ticket-list"
                      >
                        Tickets
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "sensor-stock" ? "mm-active" : ""
                        }`}
                        to="/sleep-study-sensor"
                      >
                        Sensors
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`${
                          path === "sleep-study-equipment" ? "mm-active" : ""
                        }`}
                        to="/sleep-study-equipment"
                      >
                        Consumable Supplies
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

            {this.context.currentUser &&
              this.context.currentUser.roles[0] == "super_admin" && (
                <li className={`${Backup.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i class="flaticon-381-database"></i>{" "}
                    <span className="nav-text">Backup</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${path === "backup" ? "mm-active" : ""}`}
                        to="/backup"
                        // onClick={() => (window.location.pathname = "/node-list")}
                      >
                        Backup
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            {this.context.currentUser &&
              (this.context.currentUser.roles[0] == "super_admin" ||
                this.context.currentUser.roles[0] == "sale" ||
                this.context.currentUser.roles[0] == "accountant") && (
                <li className={`${Settings.includes(path) ? "mm-active" : ""}`}>
                  <Link
                    className="has-arrow ai-icon"
                    to="#"
                    aria-expanded="false"
                  >
                    <i class="flaticon-381-controls-3"></i>{" "}
                    <span className="nav-text">Settings</span>
                  </Link>
                  <ul aria-expanded="false">
                    <li>
                      <Link
                        className={`${path === "settings" ? "mm-active" : ""}`}
                        to="/settings"
                      >
                        Settings
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
          </MM>

          {/* <div className="plus-box">
            <p>Create new appointment</p>
          </div> */}
          <div className="copyright pt-3">
            <p>
              <strong>BDSleep Study Management</strong>{" "}
            </p>
            <p>© 2023 All Rights Reserved</p>
          </div>
        </PerfectScrollbar>
        {canSharePatientPortal && this.state.showPatientPortalShare && (
          <PatientPortalShareModal
            onHide={() => this.setState({ showPatientPortalShare: false })}
          />
        )}
      </div>
    );
  }
}

const CustomerScopedSideBar = (props) => {
  const hideCustomerRestrictedMenus = useAdminCustomerMenuRestriction();
  return (
    <SideBar {...props} hideCustomerRestrictedMenus={hideCustomerRestrictedMenus} />
  );
};

export default CustomerScopedSideBar;
